import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import apiUrl from "./base_url"; // Ensure this file exists and exports the API URL

const RandomTopics = () => {
  const [topics, setTopics] = useState([]);
  const [relatedArticles, setRelatedArticles] = useState([]);

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await axios.get(`${apiUrl}serverside/latest_job.php`);
        console.log("API Response:", response.data); // Debugging
        
        // Filter out topics without a valid name
        const validTopics = response.data.filter(topic => topic.name);
        
        // Shuffle and pick 10 random topics
        const shuffledTopics = validTopics.sort(() => 0.5 - Math.random()).slice(0, 10);
        setTopics(shuffledTopics);
      } catch (error) {
        console.error("Error fetching topics:", error);
      }
    };

    const fetchRelatedArticles = async () => {
      try {
        const response = await axios.get(`${apiUrl}serverside/latest_job.php`);
        const latestArticles = response.data
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 20);

        setRelatedArticles(latestArticles);
      } catch (error) {
        console.error("Failed to fetch related articles:", error);
      }
    };

    fetchTopics();
    fetchRelatedArticles();
  }, []);

  return (
    <div className="mt-3 p-3 bg-light shadow-sm">
      <h5 className="text-center text-info">Explore More Topics</h5>
      <ul className="list-group">
        {topics.map((topic) => (
          <li key={topic.id} className="list-group-item">
            <Link
              to={topic.name ? `/mcq/${topic.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : "#"}
              className="text-decoration-none"
            >
              {topic.name || "Untitled Topic"}
            </Link>
          </li>
        ))}
      </ul>

      <h5 className="mt-4">Related Articles</h5>
      <ul className="list-unstyled">
        {relatedArticles.map((article) => {
          const slug = article.topic_name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
          return (
            <li key={article.id}>
              <Link to={`/job_detail/${slug}`}>
                {article.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RandomTopics;
